<template>
  <div class="wcon">
    <Banner />

    <div class="w">
      <div class="row_1">
        <div>
          <CarouselArticleListWindow
            :isHomePage="isHomePage"
            articleModel="3001"
            icon="el-icon-notebook-2"
            title="学校要闻"
            style="height: 420px;"
          />
        </div>
      </div>
    </div>
    <div class="row_2_3">
      <div class="mc">
        <div class="row_2_3_top"></div>
        <div class="w">
          <div class="row_2">
            <div>
              <ArticleListWindowThree
                :isHomePage="isHomePage"
                articleModel="3002"
                icon="el-icon-mic"
                title="通知公告"
                enTitle="ANNOUNCEMENT"
                style="height: 465px;"
              />
            </div>
            <div>
              <ArticleListWindow
                :isHomePage="isHomePage"
                articleModel="3003"
                icon="el-icon-user"
                title="人才培养"
                enTitle="PRESONNEL TRAINING"
                style="height: 420px;"
              />
            </div>
          </div>
          <div class="row_3">
            <div>
              <ArticleListWindowFour
                :isHomePage="isHomePage"
                articleModel="3004"
                icon="el-icon-video-camera-solid"
                title="媒体关注"
                enTitle="MEDIA ATTENTION"
                style="height: 420px;"
              />
            </div>
            <div>
              <ArticleListWindowTwo
                :isHomePage="isHomePage"
                articleModel="3005"
                icon="el-icon-video-camera-solid"
                title="信息公开"
                enTitle="FOCUS NEWS"
                style="height: 420px;"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w">
      <div class="row_4">
        <div>
          <Featured />
        </div>
        <div>
          <FastTrack />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "@/components/Banner";
import ArticleListWindow from "@/components/ArticleListWindow";
import ArticleListWindowTwo from "@/components/ArticleListWindowTwo";
import ArticleListWindowThree from "@/components/ArticleListWindowThree";
import ArticleListWindowFour from "@/components/ArticleListWindowFour";
import CarouselArticleListWindow from "@/components/CarouselArticleListWindow";
import CampusStyle from "@/components/CampusStyle";
import Featured from "@/components/Featured";
import FastTrack from "@/components/FastTrack";

export default {
  name: "IndexContent",
  components: {
    Banner,
    ArticleListWindow,
    CarouselArticleListWindow,
    ArticleListWindowTwo,
    ArticleListWindowThree,
    ArticleListWindowFour,
    CampusStyle,
    Featured,
    FastTrack
  },
  data() {
    return {
      isHomePage: "1"
    };
  }
};
</script>
<style scoped>
.w > div {
  margin-top: 30px;
}

.row_1 {
  display: flex;
}

.row_1 > div:first-child {
  flex: 2;
  margin: 0 0.05rem;
}

.row_1 > div:last-child {
  flex: 1;
}

.mc {
  background: linear-gradient(to bottom, #ffffff99, #fff);
  padding-top: 1px;
}

.row_2_3 {
  background-image: url("../assets/imgs/1605836289_8461_thumb.jpg");
  background-size: cover;
  background-position: center;
  margin-top: 20px;
}

.row_2_3_top {
  height: 40px;
  background: linear-gradient(to bottom, #87ceeb88, #fff0);
}

.row_2 {
  display: flex;
}

.row_1 > div,
.row_2 > div,
.row_3 > div,
.row_4 > div {
  flex: 1;
  padding: 10px 0.2rem;
}

.row_2,
.row_3,
.row_4 {
  display: flex;
}

@media screen and (max-width: 768px) {
  .wcon {
    width: 100%;
    position: static;
    overflow-x: hidden;
  }

  .row_2,
  .row_3,
  .row_4 {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/IndexContent.vue